import { render } from "./InsuranceCompanyPage.vue?vue&type=template&id=4562b7c6&scoped=true"
import script from "./InsuranceCompanyPage.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyPage.vue?vue&type=script&lang=js"

import "./InsuranceCompanyPage.vue?vue&type=style&index=0&id=4562b7c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4562b7c6"]])

export default __exports__